import { render, staticRenderFns } from "./BasicInformationAboutSubjectInput.vue?vue&type=template&id=40091894&"
import script from "./BasicInformationAboutSubjectInput.vue?vue&type=script&lang=js&"
export * from "./BasicInformationAboutSubjectInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports